import { View } from "extensions/marionette";
import $ from "jquery";

import { updateStickyItemsWidth } from "common/utils";
import { store } from "common/store";

import loaderTemplate from "common/helpers/horizontal-loader.jst";
import { listenForMediaQueryChange, stopListeningForMediaQueryChange } from "common/helpers/mediaqueryListener";
import { TokenObserver } from "common/components/tokenObserver/tokenObserver";

import genericLayoutTemplate from "./appLayout.jst";

import "./topbar.scss";

const SCROLL_THRESHOLDS = [
    51, // Regular page-level tabs, section name, and the datepicker
    168, // Reconciliation summaries
    255, // Reconciliation transactions
    225 // Analytics transactions
];

export const AppLayout = View.extend({
    stickyTabs: true,
    template: genericLayoutTemplate,
    
    regions: {
        topBar: "#topbar-wrapper",
        leftSidebar: "#sidebar-wrapper",
        content: {
            replaceElement: true,
            el: "#page-content-wrapper"
        }
    },
    
    initialize() {
        this.monitorScroll = true;
    },
    
    listenForResize() {
        $(window).on("resize.app", () => {
            window.requestAnimationFrame(() => {
                updateStickyItemsWidth();
            });
        });
    },
    
    stopListenForResize() {
        $(window).off("resize.app");
    },
    
    listenForScroll() {
        $(window).on("scroll.app", () => {
            if (this.monitorScroll === false) return;
            
            window.requestAnimationFrame(() => {
                const scrollTop = document.documentElement.scrollTop;
                SCROLL_THRESHOLDS.forEach((val) => {
                    if (scrollTop >= val) {
                        updateStickyItemsWidth();
                        document.body.classList.add(`scrolled-${val}`);
                    } else {
                        document.body.classList.remove(`scrolled-${val}`);
                    }
                });
            });
        });
    },
    
    stopListeningForScroll() {
        $(window).off("scroll.app");
    },
    
    showTokenLifetimeComponent() {
        this.$el.append("<div id='tokenObserver'/>");
        this.addRegion("tokenObserver", {
            el: "#tokenObserver"
        });
        this.showChildView("tokenObserver", new TokenObserver());
    },
    
    onRender() {
        if (this.getOption("stickyTabs")) {
            this.listenForScroll();
            this.listenForResize();
            listenForMediaQueryChange();
        }
        
        if (store.getState().settings.viewInspector) {
            this.showTokenLifetimeComponent();
        }
    },
    
    onDestroy() {
        if (this.getOption("stickyTabs")) {
            this.stopListeningForScroll();
            this.stopListenForResize();
            stopListeningForMediaQueryChange();
        }
    },
    
    updatePageName(page_name) {
        const excludePagesFromStickyScroll = ["comparisons", "benchmarks"];
        
        // This call below should go to some other controller, but keeping it's here for now
        // set property on body to allow page-specific CSS styles.
        // removing spaces per spec on html attributes
        $("body").attr("data-page", page_name);
        
        this.monitorScroll = !excludePagesFromStickyScroll.includes(page_name);
        if (this.monitorScroll === false) {
            SCROLL_THRESHOLDS.forEach((val) => document.body.classList.remove(`scrolled-${val}`));
        }
    },
    
    templateContext() {
        return {
            loader: loaderTemplate()
        };
    }
});
